import createReducer from '../utils/createReducer';
import datePickerActions from '../actions/datePickerActions';
import DatePickerRecord from '../records/datePickerRecord';

const initialState = new DatePickerRecord();

const actionHandlers = {
    [datePickerActions.CHANGED_SELECTED_DATES](state, {payload = {}}) {
        const {fieldsChanged} = payload;
        return state.merge(fieldsChanged);
    },
    [datePickerActions.DATE_INPUT_FOCUS](state, {payload = {}}) {
        const {selectingCheckout} = payload;
        return state.merge({selectingCheckout});
    },
    [datePickerActions.UPDATE_DATE_PICKER_STATE](
        state,
        {payload = {datePickerState: null, datePickerPrevState: null}}
    ) {
        const {datePickerPrevState, datePickerState} = payload;

        return state.merge({
            datePickerPrevState,
            datePickerState
        });
    },
    [datePickerActions.DISABLED_DAY_CLICK_ATTEMPT](state, {payload = {}}) {
        const {date} = payload;

        return state.merge(date);
    },
    [datePickerActions.REMOUNT_DATE_PICKER](state) {
        return state.merge({remountKey: !state.remountKey});
    }
};

export default createReducer(actionHandlers, initialState);
